import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { PartecipataDto } from '@ideapa/common-dto';
import { Observable } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class PartecipataApiClient extends BaseCRUDApiClient<PartecipataDto> {
  baseUrl = this.config.apiEndpoint + '/partecipata';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  findByCodiceFiscale(codiceFiscale: string) {
    return this.http.get<PartecipataDto>(
      `${this.baseUrl}/find-by-codice-fiscale/${codiceFiscale}`
    );
  }

  findMinDataCessione(idPartecipataEnte: number) {
    return this.http.get<{ dataMin: string }>(
      `${this.baseUrl}/search-min-data-cessione/${idPartecipataEnte}`
    );
  }

  unlinkPartecipata(idPartecipata: number): Observable<PartecipataDto> {
    this._pagedCache.clear();
    return this.http.get<PartecipataDto>(
      `${this.baseUrl}/unlink-partecipata-ente/${idPartecipata}`
    );
  }
}
